module.exports = __webpack_public_path__ + "static/img/4.959c222.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/4.png
// module id = q72Q
// module chunks = 1